import { ApiResponse } from 'apisauce';

import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import {
  GuestAudienceFilterOptionsModel,
  GuestAudienceModel,
  GuestAudienceResponseModel,
  GuestAudienceSearchModel
} from '../shared/models/guest-audience.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'MARKETING_MODULE';

export function getGuestAudience(
  query: GuestAudienceSearchModel
): Promise<GuestAudienceModel | ErrorInfo> {
  return api
    .getGuestAudience(query)
    .then((response: ApiResponse<GuestAudienceResponseModel, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return {
            rows: data.data,
            count: data.count || 0,
            truncated: Boolean(data.truncated)
          };
        }

        return errorHelper(0, '', MODULE_NAME, (api.getGuestAudience as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getGuestAudience as any).displayName
      );
    });
}

/**
 * The export comes back as a CSV body, not JSON, so the raw payload is returned for the caller to
 * turn into a download. A failure still arrives as JSON, which is why the ok check comes first.
 */
export function exportGuestAudience(
  query: GuestAudienceSearchModel
): Promise<Blob | string | ErrorInfo> {
  return api.exportGuestAudience(query).then((response: ApiResponse<any, ErrorInfo>) => {
    if (response.ok && response.data) {
      return response.data as Blob | string;
    }

    // `data` is typed loosely here because a successful export is a CSV body, so the error branch
    // gets no narrowing and `problem` stays nullable — unlike the JSON calls above.
    return errorHelper(
      Number(response.status),
      response.data && response.data.errorCode
        ? String(response.data.errorCode || '')
        : String(response.problem || ''),
      MODULE_NAME,
      (api.exportGuestAudience as any).displayName
    );
  });
}

export function getGuestAudienceFilterOptions(): Promise<
  GuestAudienceFilterOptionsModel | ErrorInfo
> {
  return api
    .getGuestAudienceFilterOptions()
    .then((response: ApiResponse<ResponseModel<GuestAudienceFilterOptionsModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        }

        return errorHelper(
          0,
          '',
          MODULE_NAME,
          (api.getGuestAudienceFilterOptions as any).displayName
        );
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getGuestAudienceFilterOptions as any).displayName
      );
    });
}
